import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-clans/$tag/matches")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/my-clans/$tag/player-search/results",
      params,
    });
  },
});
